import React from "react";
import StepModal from "modules/swiftboard/components/ui/StepModal";
import { useAlert } from "context/AlertContext";
import useCampaignWizard from "./useCampaignWizard";
import StepDetails from "./steps/StepDetails";
import StepAudience from "./steps/StepAudience";
import StepRecipients from "./steps/StepRecipients";
import StepTemplate from "./steps/StepTemplate";
import StepSchedule from "./steps/StepSchedule";
import StepReview from "./steps/StepReview";

const CampaignWizardModal = ({ isOpen, onClose, onSuccess }) => {
  const { showAlert } = useAlert();
  const wizard = useCampaignWizard({ isOpen });

  if (!isOpen) return null;

  const handleFinish = async () => {
    try {
      const res = await wizard.finish();
      showAlert({ type: "success", message: res?.data?.message || "Campaign queued for sending." });
      onSuccess?.();
      onClose();
    } catch (err) {
      showAlert({ type: "error", message: err.response?.data?.message || "Failed to create campaign." });
    }
  };

  const renderStep = () => {
    switch (wizard.STEPS[wizard.step].key) {
      case "details":
        return <StepDetails formData={wizard.formData} setField={wizard.setField} errors={wizard.errors} />;
      case "audience":
        return <StepAudience audienceFilter={wizard.audienceFilter} setFilterField={wizard.setFilterField} />;
      case "recipients":
        return (
          <StepRecipients
            resolvedRecipients={wizard.resolvedRecipients}
            removeRecipient={wizard.removeRecipient}
            resolving={wizard.resolving}
          />
        );
      case "template":
        return <StepTemplate selectedTemplate={wizard.selectedTemplate} setSelectedTemplate={wizard.setSelectedTemplate} />;
      case "schedule":
        return (
          <StepSchedule
            sendMode={wizard.sendMode}
            setSendMode={wizard.setSendMode}
            scheduledAt={wizard.scheduledAt}
            setScheduledAt={wizard.setScheduledAt}
            timeZone={wizard.timeZone}
          />
        );
      case "review":
        return (
          <StepReview
            formData={wizard.formData}
            resolvedRecipients={wizard.resolvedRecipients}
            selectedTemplate={wizard.selectedTemplate}
            sendMode={wizard.sendMode}
            scheduledAt={wizard.scheduledAt}
            timeZone={wizard.timeZone}
          />
        );
      default:
        return null;
    }
  };

  return (
    <StepModal
      isOpen={isOpen}
      onClose={onClose}
      title="New Campaign"
      steps={wizard.STEPS}
      currentStep={wizard.step}
      canGoNext={wizard.canGoNext && !wizard.resolving}
      canFinish
      onNext={wizard.goNext}
      onBack={wizard.goBack}
      onFinish={handleFinish}
      finishLabel="Done"
      isSubmitting={wizard.submitting || wizard.resolving}
    >
      {renderStep()}
    </StepModal>
  );
};

export default CampaignWizardModal;
